<!-- ROOT CONTAINER - START -->
<ng-container>
    <!-- WRAPPER AND LAYOUT - START -->
    <div class="wrpr">
        <div class="loginCont">
            <!-- ANIMATION SECTION - START -->
            <div class="animationCont">
                <a routerLink="/home" class="logoLink">
                    <img src="../../../../assets/images/Dmint_Logo.svg" alt="CoolBrand" class="" />
                </a>
                <h1>Welcome to DMINT!</h1>
                <p>Your digital companions are ready to help you succeed!</p>
                <div class="svgCont">
                    <svg width="100%" height="100%" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"
                        id="eyesAnimation">
                        <defs>
                            <!-- Shadow filter -->
                            <filter id="shape-01-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#8F75FA" flood-opacity="1" />
                            </filter>
                            <filter id="shape-02-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#8F75FA" flood-opacity="1" />
                            </filter>
                            <filter id="shape-03-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#7096FF" flood-opacity="1" />
                            </filter>
                            <filter id="shape-04-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#FF9A70" flood-opacity="1" />
                            </filter>
                            <filter id="shape-05-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#7096FF" flood-opacity="1" />
                            </filter>
                            <filter id="shape-06-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#FF9A70" flood-opacity="1" />
                            </filter>
                            <filter id="shape-07-shadow" x="-50%" y="-50%" width="200%" height="200%">
                                <feDropShadow _ngcontent-ng-c1092356836="" dx="6" dy="6" stdDeviation="1"
                                    flood-color="#FF9A70" flood-opacity="1" />
                            </filter>

                            <!-- Clipping paths for each eye socket -->
                            <clipPath id="clip-shape01">
                                <rect x="389" y="150" width="56" height="54" rx="27" />
                            </clipPath>
                            <clipPath id="clip-shape02-left">
                                <rect x="406.133" y="351" width="56" height="80" rx="28"
                                    transform="rotate(8 406.133 351)" />
                            </clipPath>
                            <clipPath id="clip-shape02-right">
                                <rect x="457.754" y="377.938" width="56" height="45.7915" rx="22.8958"
                                    transform="rotate(8 457.754 377.938)" />
                            </clipPath>
                            <clipPath id="clip-shape03-left">
                                <rect x="590" y="633" width="56" height="26" rx="18"
                                    transform="rotate(0 587.121 636.822)" />
                            </clipPath>
                            <clipPath id="clip-shape03-right">
                                <rect x="652.367" y="624.793" width="56" height="26" rx="18"
                                    transform="rotate(-1 651.367 627.793)" />
                            </clipPath>
                            <clipPath id="clip-shape04-left">
                                <rect x="216.172" y="378.918" width="56" height="26" rx="13"
                                    transform="rotate(-1.0788 216.172 378.918)" />
                            </clipPath>
                            <clipPath id="clip-shape04-right">
                                <rect x="264.199" y="360.307" width="56" height="26" rx="13"
                                    transform="rotate(1.9212 262.199 360.307)" />
                            </clipPath>
                            <clipPath id="clip-shape05-left">
                                <rect x="52.1211" y="491" width="56" height="26" rx="13" />
                            </clipPath>
                            <clipPath id="clip-shape05-right">
                                <rect x="108.121" y="491" width="56" height="26" rx="13" />
                            </clipPath>
                            <clipPath id="clip-shape06-left">
                                <rect x="175.449" y="126.143" width="56" height="80" rx="28"
                                    transform="rotate(24 175.449 126.143)" />
                            </clipPath>
                            <clipPath id="clip-shape06-right">
                                <rect x="222.609" y="146.92" width="56" height="80" rx="28"
                                    transform="rotate(24 222.609 146.92)" />
                            </clipPath>
                            <clipPath id="clip-shape07-left">
                                <rect x="550" y="155.338" width="56" height="80" rx="28"
                                    transform="rotate(-12 550 155.338)" />
                            </clipPath>
                            <clipPath id="clip-shape07-right">
                                <rect x="601.016" y="143.645" width="56" height="80" rx="28"
                                    transform="rotate(-12 601.016 143.645)" />
                            </clipPath>
                        </defs>
                        <!-- Shape 01 - Single eye with crown -->
                        <circle cx="417" cy="177" r="80" fill="#D0C5FD" filter="url(#shape-01-shadow)" />
                        <rect x="389" y="150" width="56" height="54" rx="27" fill="#FAFAFA" id="shape01_socket" />
                        <circle cx="417" cy="177" r="16" fill="#525252" id="shape01_eye" clip-path="url(#clip-shape01)" />
                        <path
                            d="M355.694 110.927C361.885 109.422 372.381 106.111 381.16 101.548M381.16 101.548C386.975 98.5266 392.036 94.9554 394.595 90.9952C402.625 78.57 389.387 70.5507 383.068 80.3282C379.355 86.0752 378.959 95.0393 381.16 101.548ZM381.16 101.548C382.704 106.114 385.524 109.471 389.373 109.664C392.907 109.841 398.184 108.383 403.656 106.07M403.656 106.07C412.637 102.275 422.145 96.179 425.338 91.2371C430.478 83.2841 419.221 72.9942 410.006 81.329C403.891 86.8595 401.467 98.6235 403.656 106.07ZM403.656 106.07C404.766 109.846 407.063 112.512 410.665 112.693C418.325 113.54 427.311 110.792 434.793 106.419M434.793 106.419C440.356 103.168 445.089 99.0188 447.828 94.7802C455.857 82.355 442.619 74.3357 436.301 84.1132C432.376 90.187 432.158 99.8544 434.793 106.419ZM434.793 106.419C436.401 110.422 439.069 113.272 442.605 113.449C446.14 113.626 451.417 112.168 456.889 109.855M456.889 109.855C465.87 106.06 475.377 99.9639 478.571 95.0221C483.71 87.0691 472.454 76.7792 463.239 85.114C457.124 90.6445 454.7 102.408 456.889 109.855ZM456.889 109.855C457.999 113.631 460.295 116.297 463.898 116.478"
                            stroke="#949494" stroke-width="4" stroke-linecap="round" />

                        <!-- Shape 02 - Tall rectangle with two eyes -->
                        <rect x="404.348" y="323.244" width="120" height="400" rx="16" transform="rotate(8 404.348 323.244)"
                            fill="#D0C5FD" filter="url(#shape-02-shadow)" />
                        <rect x="406.133" y="351" width="56" height="80" rx="28" transform="rotate(8 406.133 351)"
                            fill="#FAFAFA" id="shape02_left_socket" />
                        <circle cx="428.071" cy="394.071" r="16" transform="rotate(8 428.071 394.071)" fill="#525252"
                            id="shape02_left_eye" clip-path="url(#clip-shape02-left)" />
                        <rect x="457.754" y="377.938" width="56" height="45.7915" rx="22.8958"
                            transform="rotate(8 457.754 377.938)" fill="#FAFAFA" id="shape02_right_socket" />
                        <circle cx="482.293" cy="404.509" r="16" transform="rotate(8 482.293 404.509)" fill="#525252"
                            id="shape02_right_eye" clip-path="url(#clip-shape02-right)" />
                        <path
                            d="M467.581 353.302C452.328 350.503 442.621 324.268 465.418 320.617C488.214 316.967 482.592 340.896 478.19 343.268C473.788 345.64 459.426 347.02 478.363 281.608C497.299 216.197 545.509 285.638 530.355 346.057C515.202 406.475 487.32 359.889 507.886 334.082C528.453 308.274 568.093 320.383 572.216 336.678"
                            stroke="#949494" stroke-width="4" stroke-linecap="round" />

                        <!-- Shape 03 - Wide rectangle with two eyes -->
                        <rect x="519.121" y="583.492" width="240" height="160" rx="16"
                            transform="rotate(-8 519.121 583.492)" fill="#C7D6FF" filter="url(#shape-03-shadow)" />
                        <rect x="587.121" y="636.822" width="56" height="26" rx="13" transform="rotate(-8 587.121 636.822)"
                            fill="#FAFAFA" id="shape03_left_socket" />
                        <circle cx="616.552" cy="645.889" r="16" transform="rotate(-8 616.552 645.889)" fill="#525252"
                            id="shape03_left_eye" clip-path="url(#clip-shape03-left)" />
                        <rect x="651.367" y="627.793" width="56" height="26" rx="13" transform="rotate(-8 651.367 627.793)"
                            fill="#FAFAFA" id="shape03_right_socket" />
                        <circle cx="681.024" cy="636.754" r="16" transform="rotate(-8 681.024 636.754)" fill="#525252"
                            id="shape03_right_eye" clip-path="url(#clip-shape03-right)" />
                        <path
                            d="M758.032 579.537C773.285 576.737 782.992 550.502 760.196 546.851C737.399 543.201 743.022 567.131 747.423 569.503C751.825 571.874 766.187 573.254 747.251 507.843C728.314 442.431 680.105 511.873 695.258 572.291C710.411 632.709 738.293 586.123 717.727 560.316C697.161 534.509 657.20 546.618 653.398 562.912"
                            stroke="#949494" stroke-width="4" stroke-linecap="round" />

                        <!-- Shape 04 - Triangle/diamond with two eyes -->
                        <path
                            d="M311.697 333.197C323.271 328.985 335.065 338.881 332.926 351.011L312.474 467.001C310.335 479.131 295.867 484.396 286.432 476.479L196.208 400.772C186.773 392.855 189.446 377.693 201.02 373.48L311.697 333.197Z"
                            fill="#FFD6C5" filter="url(#shape-04-shadow)" />
                        <rect x="211.172" y="386.918" width="56" height="26" rx="13"
                            transform="rotate(-19.0788 211.172 386.918)" fill="#FAFAFA" id="shape04_left_socket" />
                        <circle cx="239.172" cy="399.918" r="16" transform="rotate(-19.0788 239.172 399.918)" fill="#525252"
                            id="shape04_left_eye" clip-path="url(#clip-shape04-left)" />
                        <rect x="259.199" y="370.307" width="56" height="26" rx="13"
                            transform="rotate(-19.0788 259.199 370.307)" fill="#FAFAFA" id="shape04_right_socket" />
                        <circle cx="287.199" cy="383.307" r="16" transform="rotate(-19.0788 287.199 383.307)" fill="#525252"
                            id="shape04_right_eye" clip-path="url(#clip-shape04-right)" />

                        <!-- Shape 05 - Lightning bolt with two eyes -->
                        <path
                            d="M65.6083 360.484C71.1404 343.699 89.2316 334.577 106.017 340.109C122.801 345.641 131.924 363.732 126.392 380.517L103.164 450.992C99.7528 461.343 107.462 472.001 118.36 472.001H172C182.436 472.001 192.217 477.09 198.206 485.636C204.195 494.183 205.64 505.114 202.078 514.923L190.032 548.095C184.604 563.04 201.938 575.895 214.664 566.361L233.313 552.39L233.734 552.081C242.604 545.659 254.156 544.212 264.351 548.276C274.706 552.405 282.168 561.625 284.044 572.615L305.044 695.615C308.018 713.036 296.307 729.57 278.886 732.545C261.465 735.519 244.93 723.807 241.956 706.386L234.177 660.825C232.163 649.03 218.388 643.539 208.812 650.713L124.186 714.111C112.861 722.596 97.3055 722.633 85.9384 714.204C74.5716 705.774 70.0914 690.879 74.9218 677.578L118.541 557.462C122.33 547.028 114.603 536.001 103.502 536.001H51.9999C41.733 536.001 32.0896 531.074 26.0722 522.755C20.0549 514.437 18.3945 503.735 21.6083 493.984L65.6083 360.484Z"
                            fill="#C7D6FF" filter="url(#shape-05-shadow)" />
                        <rect x="52.1211" y="491" width="56" height="26" rx="13" fill="#FAFAFA" id="shape05_left_socket" />
                        <circle cx="80.0039" cy="504.074" r="16" fill="#525252" id="shape05_left_eye"
                            clip-path="url(#clip-shape05-left)" />
                        <rect x="108.121" y="491" width="56" height="26" rx="13" fill="#FAFAFA" id="shape05_right_socket" />
                        <circle cx="136.242" cy="504" r="16" fill="#525252" id="shape05_right_eye"
                            clip-path="url(#clip-shape05-right)" />
                        <path
                            d="M178.721 437.392C172.812 439.774 162.903 444.563 154.873 450.344M154.873 450.344C149.555 454.173 145.062 458.436 143.1 462.724C136.946 476.177 151.202 482.204 156.045 471.618C158.891 465.395 157.989 456.468 154.873 450.344ZM154.873 450.344C152.687 446.049 149.412 443.134 145.576 443.497C142.053 443.832 137.042 446.036 131.96 449.113M131.96 449.113C123.62 454.164 115.091 461.567 112.644 466.918C108.705 475.529 121.327 484.088 129.244 474.512C134.498 468.157 135.2 456.167 131.96 449.113ZM131.96 449.113C130.317 445.537 127.661 443.23 124.069 443.57C116.368 443.837 107.872 447.852 101.098 453.258M101.098 453.258C96.062 457.277 91.9775 462.065 89.8782 466.654C83.7242 480.108 97.9799 486.134 102.823 475.548C105.831 468.972 104.653 459.374 101.098 453.258ZM101.098 453.258C98.9304 449.528 95.8791 447.093 92.3543 447.428C88.8312 447.762 83.8197 449.966 78.738 453.043M78.738 453.043C70.398 458.094 61.8692 465.497 59.4215 470.848C55.4825 479.459 68.1051 488.018 76.0222 478.442C81.2755 472.087 81.9782 460.097 78.738 453.043ZM78.738 453.043C77.0951 449.467 74.4385 447.16 70.8473 447.5"
                            stroke="#949494" stroke-width="4" stroke-linecap="round" />

                        <!-- Shape 06 - Tilted rectangle with two eyes -->
                        <rect x="112.184" y="80.2422" width="200" height="160" rx="16"
                            transform="rotate(24 112.184 80.2422)" fill="#FFD6C5" filter="url(#shape-06-shadow)" />
                        <rect x="175.449" y="126.143" width="56" height="80" rx="28" transform="rotate(24 175.449 126.143)"
                            fill="#FAFAFA" id="shape06_left_socket" />
                        <circle cx="184.761" cy="174.074" r="16" transform="rotate(24 184.761 174.074)" fill="#525252"
                            id="shape06_left_eye" clip-path="url(#clip-shape06-left)" />
                        <rect x="222.609" y="146.92" width="56" height="80" rx="28" transform="rotate(24 222.609 146.92)"
                            fill="#FAFAFA" id="shape06_right_socket" />
                        <circle cx="231.918" cy="194.851" r="16" transform="rotate(24 231.918 194.851)" fill="#525252"
                            id="shape06_right_eye" clip-path="url(#clip-shape06-right)" />

                        <!-- Shape 07 - Vertical rectangle with two eyes -->
                        <rect x="534.426" y="113.244" width="120" height="360" rx="16"
                            transform="rotate(-12 534.426 113.244)" fill="#FFD6C5" filter="url(#shape-07-shadow)" />
                        <rect x="550" y="155.338" width="56" height="80" rx="28" transform="rotate(-12 550 155.338)"
                            fill="#FAFAFA" id="shape07_left_socket" />
                        <circle cx="585.723" cy="188.714" r="16" transform="rotate(-12 585.723 188.714)" fill="#525252"
                            id="shape07_left_eye" clip-path="url(#clip-shape07-left)" />
                        <rect x="601.016" y="143.645" width="56" height="80" rx="28" transform="rotate(-12 601.016 143.645)"
                            fill="#FAFAFA" id="shape07_right_socket" />
                        <circle cx="636.719" cy="176.949" r="16" transform="rotate(-12 636.719 176.949)" fill="#525252"
                            id="shape07_right_eye" clip-path="url(#clip-shape07-right)" />
                    </svg>
                </div>
            </div>
            <!-- ANIMATION SECTION - END -->
            <!-- CONTENT CARD - START -->
            <div class="contentCard">
                <!-- PAGE HEADER - START -->
                <div class="pageHead">
                    <p *ngIf="!isSignup && signUpSteptwo">
                        <span>
                            <img src="../../../../assets/images/East.svg" alt="" style="max-height: 16px; margin-top: -4px; margin-right: 4px;">
                            <a (click)="backToSignupStepOne()" class="dmintLink blueLink">
                                {{ 'Back to signup' }}
                            </a>
                        </span>
                    </p>
                    <h1 *ngIf="forgotGroup">
                        {{ isForgetPassword ? 'FORGOT YOUR PASSWORD?':'RESET YOUR PASSWORD' }}
                    </h1>
                    <h1 *ngIf="!forgotGroup">
                        {{ isSignup ? 'LOGIN':'CREATE YOUR ACCOUNT' }}
                    </h1>
                    <p *ngIf="forgotGroup">
                        {{ isForgetPassword ? 'Please provide your registered email to receive the verification code for password recovery.':
                        'Please provide the verification code sent to your registered email.' }}
                    </p>
                    <p *ngIf="!forgotGroup && isSignup">
                        {{ 'Please provide your credentials to continue. Fields marked with * are mandatory' }}
                    </p>
                    <p *ngIf="!forgotGroup && !isSignup && !signUpSteptwo">
                        {{ 'Let\'s get you set up with a new account. Fields marked with * are mandatory' }}
                    </p>
                    <p *ngIf="!forgotGroup && !isSignup && signUpSteptwo">
                        {{ 'Almost there! Please enter the verification code sent to' }} <span class="emailEntered">{{ mainLoginForm.get('emailForSignUp')?.value }}</span>
                    </p>
                </div>
                <!-- PAGE HEADER - END -->
                <!-- FORMS SECTION - START -->
                <div class="formsCont" *ngIf="forgotGroup">
                    <form class="form" *ngIf="isForgetPassword" (ngSubmit)="onSubmit()" [formGroup]="loginForm">
                        <div class="errorCont"
                            *ngIf="loginForm.get('email').hasError('emailExists') && loginForm.get('email').dirty">
                            <img src="/assets/images/failed.svg" alt="">
                            <p> {{ loginForm.get('email').getError('errorMessage') }}</p>
                        </div>

                        <div class="errorCont"
                            *ngIf="loginForm.get('email')?.errors?.['required'] && loginForm.get('email').dirty">
                            <p>Email is required</p>
                        </div>
                        <div class="errorCont"
                            *ngIf="loginForm.get('email')?.errors?.['pattern'] && loginForm.get('email').dirty">
                            <p>Email is invalid</p>
                        </div>
                        <!-- Display the custom error message from the validator (blur)="checkExistingUserStatus()"-->
                        <div class="formControl" *ngIf="isForgetPassword">
                            <label class="formLabel required" for="emailToVerify">
                                Email Address
                            </label>
                            <input id="emailToVerify" autocomplete="false" type="email" class="inputField" required
                                formControlName="email"
                                [class.invalid]="loginForm.get('email')?.invalid && loginForm.get('email').touched">
                            <img src="/assets/images/email_icon.svg" alt="email-icon" class="emailIcon">
                        </div>

                        <button class="primary" type="submit" [disabled]="isLoginFormValid()">
                            {{ 'Send Code' }}
                        </button>
                        <a (click)="backToLogin()" class="dmintLink">
                            {{ isSignup ? '' : 'Back to Login' }}
                        </a>
                    </form>

                    <form class="form" *ngIf="!isForgetPassword" [formGroup]="resetForm">
                        <div class="errorCont"
                            *ngIf="resetForm.get('confirmPassword')?.dirty&&resetForm?.errors?.['passwordsMismatch']">
                            <img src="/assets/images/failed.svg" alt="">
                            <p> {{'Passwords do not match.'}}</p>
                        </div>
                        <div class="errorCont"
                            *ngIf="resetForm.get('verificationCode')?.dirty && resetForm.get('verificationCode').hasError('expiredCode')">
                            <img src="/assets/images/failed.svg" alt="">
                            <p>{{ resetForm.get('verificationCode').getError('errorMessage') }}</p>
                        </div>
                        <div class="formControl">
                            <label class="formLabel required" for="verificationCode">
                                Verification Code
                            </label>
                            <input id="verificationCode" placeholder="Enter 8-digit code" autocomplete="false" type="text" class="inputField" required
                                formControlName="verificationCode"
                                [class.invalid]="isSubmitted && resetForm.get('verificationCode')?.invalid">
                            <p style="display:flex; align-items: center;" class="resendLink">{{codeExpText}}
                                <span style="margin-left: 0.25rem;" *ngIf="isShowTimer"
                                    class="resendLink">{{timer}}</span>
                                <button style="margin-left: 0.25rem;" *ngIf="!isShowTimer" class="dmintLink"
                                    (click)="resendCode()">Resend Code</button>
                            </p>
                        </div>
                        <div class="formControl">
                            <label class="formLabel required" for="newPass">
                                New Password
                            </label>
                            <input id="newPass" autocomplete="false" [type]="isPasswordHidden ? 'password' : 'text'"
                                class="inputField" required formControlName="newPassword"
                                [class.invalid]="isSubmitted && resetForm.get('newPassword')?.invalid" (focus)="onPasswordFocus()"
                            (blur)="onPasswordBlur()">
                            <img *ngIf="isPasswordHidden" (click)="showHidePass()"
                                src="/assets/images/password-show.svg" alt="show-password-icon" title="Show Password"
                                class="passwordIcon">
                            <img *ngIf="!isPasswordHidden" (click)="showHidePass()"
                                src="/assets/images/password-hide.svg" alt="hide-password-icon" title="Hide Password"
                                class="passwordIcon">

                                 <div class="passRequirements" *ngIf="!isForgetPassword && passwordReqVisible">
                            <p>Please make sure that the password contains:</p>
                            <ul>
                                <li>
                                    <img *ngIf="!isPasswordValid().hasSpecialCharacter"
                                        src="/assets/images/validateMe.svg" alt="before-valid-icon" title="validateMe"
                                        class="validateMe">
                                    <img *ngIf="isPasswordValid().hasSpecialCharacter"
                                        src="/assets/images/validatedMe.svg" alt="after-valid-icon" title="validated"
                                        class="validated">
                                    atleast one special character (e.g., !, &#64;, #, $, %, ^, &, *, etc.).
                                </li>
                                <li>
                                    <img *ngIf="!isPasswordValid().hasCapitalLetter" src="/assets/images/validateMe.svg"
                                        alt="before-valid-icon" title="validateMe" class="validateMe">
                                    <img *ngIf="isPasswordValid().hasCapitalLetter" src="/assets/images/validatedMe.svg"
                                        alt="after-valid-icon" title="validated" class="validated">
                                    atleast one capital case character and one lower case character
                                </li>
                                <li>
                                    <img *ngIf="!isPasswordValid().hasNumber" src="/assets/images/validateMe.svg"
                                        alt="before-valid-icon" title="validateMe" class="validateMe">
                                    <img *ngIf="isPasswordValid().hasNumber" src="/assets/images/validatedMe.svg"
                                        alt="after-valid-icon" title="validated" class="validated">
                                    atleast one number
                                </li>
                                <li>
                                    <img *ngIf="!isPasswordValid().isLongEnough" src="/assets/images/validateMe.svg"
                                        alt="before-valid-icon" title="validateMe" class="validateMe">
                                    <img *ngIf="isPasswordValid().isLongEnough" src="/assets/images/validatedMe.svg"
                                        alt="after-valid-icon" title="validated" class="validated">
                                    should have minimum length of 8 characters
                                </li>
                            </ul>
                        </div>
                        </div>
                        <div class="formControl">
                            <label class="formLabel required" for="conPass">
                                Confirm Password
                            </label>
                            <input id="conPass" autocomplete="false"
                                [type]="isConfirmPasswordHidden ? 'password' : 'text'" class="inputField" required
                                formControlName="confirmPassword"
                                [class.invalid]="isSubmitted && resetForm.get('confirmPassword')?.invalid">
                            <img *ngIf="isConfirmPasswordHidden" (click)="showHideConfirmPass()"
                                src="/assets/images/password-show.svg" alt="show-password-icon" title="Show Password"
                                class="passwordIcon">
                            <img *ngIf="!isConfirmPasswordHidden" (click)="showHideConfirmPass()"
                                src="/assets/images/password-hide.svg" alt="hide-password-icon" title="Hide Password"
                                class="passwordIcon">
                        </div>
                       


                        <button class="primary" type="submit" (click)="onSubmit()" [disabled]="isResetFormValid()">
                            {{ 'Reset Password' }}
                        </button>
                        <a (click)="backToLogin()" class="dmintLink">
                            {{ 'Back to Login' }}
                        </a>
                    </form>
                </div>


                <form class="form" *ngIf="!forgotGroup" [formGroup]="mainLoginForm" (ngSubmit)="onLoginSubmit()">
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('emailForLogin').hasError('emailExists') && mainLoginForm.get('emailForLogin').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p> {{ mainLoginForm.get('emailForLogin').getError('errorMessage') }}</p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('emailForLogin')?.errors?.['required'] && mainLoginForm.get('emailForLogin').dirty">
                        <p>Email is required</p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('emailForLogin')?.errors?.['pattern'] && mainLoginForm.get('emailForLogin').dirty">
                        <p>Email is invalid</p>
                    </div>

                    <!-- error msg for first name starts -->
                    <div class="errorCont" *ngIf="
                                mainLoginForm.get('firstNameForSignUp')?.hasError('required') &&
                                mainLoginForm.get('firstNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            First name is required
                        </p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('firstNameForSignUp')?.hasError('minlength') &&mainLoginForm.get('firstNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            First name should be atleast 2 characters long
                        </p>
                    </div>
                    <div class="errorCont"
                        *ngIf=" mainLoginForm.get('firstNameForSignUp')?.hasError('maxlength') && mainLoginForm.get('firstNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            First name should not be more than 50 characters
                        </p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('firstNameForSignUp')?.hasError('pattern') && mainLoginForm.get('firstNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            First name should only contain alphabetic characters
                        </p>
                    </div>
                    <!-- error msg for first name ends -->

                    <!-- error msg for last name starts -->
                    <div class="errorCont" *ngIf="
                                mainLoginForm.get('lastNameForSignUp')?.hasError('required') &&
                                mainLoginForm.get('lastNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            Last name is required
                        </p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('lastNameForSignUp')?.hasError('minlength') &&mainLoginForm.get('lastNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            Last name should be atleast 2 characters long
                        </p>
                    </div>
                    <div class="errorCont"
                        *ngIf=" mainLoginForm.get('lastNameForSignUp')?.hasError('maxlength') && mainLoginForm.get('lastNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            Last name should not be more than 50 characters
                        </p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('lastNameForSignUp')?.hasError('pattern') && mainLoginForm.get('lastNameForSignUp')?.dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            Last name should only contain alphabetic characters
                        </p>
                    </div>
                    <!-- error msg for Last name ends -->
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('emailForSignUp').hasError('required') && mainLoginForm.get('emailForSignUp').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p> Email Id is required</p>
                    </div>
                    <div class="errorCont" *ngIf="mainLoginForm.get('emailForSignUp').hasError('pattern') && mainLoginForm.get('emailForSignUp').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p > Email Id is invalid</p>
                    </div>
                    <div class="errorCont" *ngIf="mainLoginForm.get('emailForSignUp').hasError('emailExists') && mainLoginForm.get('emailForSignUp').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p> {{ mainLoginForm.get('emailForSignUp').getError('errorMessage') }}</p>
                    </div>

                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('customCompanyName').hasError('companyExists') && mainLoginForm.get('customCompanyName').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p> {{ mainLoginForm.get('customCompanyName').getError('errorMessage') }}</p>
                    </div>
                    <div class="errorCont"
                        *ngIf="mainLoginForm.get('customCompanyName').hasError('required') && mainLoginForm.get('customCompanyName').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p> Company Name is required</p>
                    </div>
                    <!-- Display password validation errors -->
                    <!-- <div class="errorCont" *ngIf="mainLoginForm.get('passForSignup').hasError('passwordInvalid') 
            && mainLoginForm.get('passForSignup').hasError('missingUpperCase') 
            && mainLoginForm.get('passForSignup').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>Password must contain at least one uppercase letter.</p>
                    </div> -->
                    <div class="errorCont" *ngIf="mainLoginForm.get('passForSignup').hasError('required') 
                                && mainLoginForm.get('passForSignup').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>Password is required.</p>
                    </div>
                    <!-- <div class="errorCont" *ngIf="mainLoginForm.get('passForSignup').hasError('passwordInvalid') 
                                && mainLoginForm.get('passForSignup').hasError('missingLowerCase') 
                                && mainLoginForm.get('passForSignup').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>Password must contain at least one lowercase letter.</p>
                    </div>

                    <div class="errorCont" *ngIf="mainLoginForm.get('passForSignup').hasError('passwordInvalid') 
                                && mainLoginForm.get('passForSignup').hasError('missingNumber') 
                                && mainLoginForm.get('passForSignup').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>Password must contain at least one number.</p>
                    </div>

                    <div class="errorCont" *ngIf="mainLoginForm.get('passForSignup').hasError('passwordInvalid') 
                                && mainLoginForm.get('passForSignup').hasError('missingSpecialChar') 
                                && mainLoginForm.get('passForSignup').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>Password must contain at least one special character.</p>
                    </div>

                    <div class="errorCont" *ngIf="mainLoginForm.get('passForSignup').hasError('passwordInvalid') 
                                && mainLoginForm.get('passForSignup').hasError('tooShort') 
                                && mainLoginForm.get('passForSignup').dirty">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>Password must be at least 8 characters long.</p>
                    </div> -->

                    <div class="errorCont"
                        *ngIf="(mainLoginForm.get('verificationCodeForSignUp')?.hasError('minlength') &&mainLoginForm.get('verificationCodeForSignUp')?.dirty) || (mainLoginForm.get('verificationCodeForSignUp')?.hasError('maxlength') &&mainLoginForm.get('verificationCodeForSignUp')?.dirty)">
                        <img src="/assets/images/failed.svg" alt="">
                        <p>
                            Verification code must be 8 digits long
                        </p>
                    </div>
                    <!-- Display the custom error message from the validator (blur)="checkExistingUserStatus()"-->
                    <div class="twoCol_fullW" *ngIf="!isSignup && !signUpSteptwo">
                        <div class="formControl widAuto" *ngIf="!isSignup && !signUpSteptwo" >
                            <label class="formLabel required" for="firstNameForSignUp">
                                First Name
                            </label>
                            <input id="firstNameForSignUp" placeholder="Enter your name" autocomplete="false" type="text"
                                class="inputField" required
                                [class.invalid]="mainLoginForm.get('firstNameForSignUp')?.invalid && mainLoginForm.get('firstNameForSignUp').dirty"
                                required formControlName="firstNameForSignUp">
                        </div>
                        <div class="formControl widAuto" *ngIf="!isSignup && !signUpSteptwo">
                            <label class="formLabel required" for="lastNameForSignUp">
                                Last Name
                            </label>
                            <input id="lastNameForSignUp" placeholder="Enter your name" autocomplete="false" type="text"
                                class="inputField"
                                [class.invalid]="mainLoginForm.get('lastNameForSignUp')?.invalid && mainLoginForm.get('lastNameForSignUp').dirty"
                                required formControlName="lastNameForSignUp">
                        </div>
                    </div>
                    <div class="formControl" *ngIf="!isSignup && !signUpSteptwo">
                        <label class="formLabel required" for="emailForSignUp">
                            Email Address
                        </label>
                        <input id="emailForSignUp" placeholder="Enter your email" autocomplete="false" type="email"
                            class="inputField"
                            [class.invalid]="mainLoginForm.get('emailForSignUp')?.invalid && mainLoginForm.get('emailForSignUp').dirty"
                            required formControlName="emailForSignUp">
                        <img src="/assets/images/email_icon.svg" alt="email-icon" class="emailIcon">
                    </div>

                    <div class="formControl" *ngIf="isSignup">
                        <label class="formLabel required" for="emailForLogin">
                            Email Address
                        </label>
                        <input id="emailForLogin" placeholder="Enter your email" autocomplete="false" type="email"
                            class="inputField"
                            [class.invalid]="mainLoginForm.get('emailForLogin')?.invalid && mainLoginForm.get('emailForLogin').dirty"
                            required formControlName="emailForLogin">
                        <img src="/assets/images/email_icon.svg" alt="email-icon" class="emailIcon">
                    </div>

                    <div class="formControl company" *ngIf="!isSignup && !signUpSteptwo">
                        <label class="formLabel required">Company</label>
                        <button type="button" class="toggleCont" (click)="showOptions()">
                            <p class="placeHolder" *ngIf="selectedCompany.length === 0">Select Company</p>
                            <span *ngIf="selectedCompany.length" class="optionSelected"
                                title="{{selectedCompany.join(', ')}}">{{ selectedCompany.join(', ')}}</span>
                            <img src="/assets/images/chevron-south.svg" alt="chevron-south">
                        </button>
                        <div class="optionsCont" *ngIf="isCompanyOpen">
                            <!-- Search input -->
                            <div class="searchCont">
                                <input type="text" class="inputField noShadow" placeholder="Search companies"
                                    [value]="searchTerm()" (input)="onSearchChange($event)"
                                    (click)="$event.stopPropagation()">
                            </div>
                            <!-- Filtered company options -->
                            <button type="button" class="option"
                                *ngFor="let item of filteredCompanies(); trackBy: trackByCompanyId"
                                (click)="selectCompany(item)">
                                {{ item.companyName | uppercase }}
                            </button>
                            <!-- "Other" option -->
                            <!-- <button type="button" class="option other-option" *ngIf="showOtherOption()" (click)="selectCompany('Other')">
                                Other
                            </button> -->
                            <!-- No results message -->
                            <div class="no-results" *ngIf="filteredCompanies().length === 0 && searchTerm().length > 0">
                                No companies found matching "{{ searchTerm() }}"
                            </div>
                        </div>
                        <!-- Hidden input for form control integration -->
                        <input type="hidden" formControlName="selectedCompany"
                            [class.invalid]="mainLoginForm.get('selectedCompany')?.invalid && mainLoginForm.get('selectedCompany').dirty">
                    </div>

                    <!-- Custom company name input (shown when "Other" is selected) -->
                    <div class="formControl" *ngIf="isOtherSelected()">
                        <label class="formLabel required" for="customCompanyName">
                            Other
                        </label>
                        <input id="customCompanyName" type="text" class="inputField" placeholder="Enter your company"
                            [value]="customCompanyName()" (input)="onCustomCompanyChange($event)"
                            formControlName="customCompanyName" required
                            [class.invalid]="mainLoginForm.get('customCompanyName')?.invalid && mainLoginForm.get('customCompanyName').dirty">
                    </div>

                    <div class="formControl" *ngIf="isSignup">
                        <label class="formLabel required" for="passForLogin">
                            Password
                        </label>
                        <input id="passForLogin" placeholder="Enter your password" autocomplete="false"
                            [type]="isPasswordHidden ? 'password' : 'text'" class="inputField"
                            [class.invalid]="mainLoginForm.get('passForLogin')?.invalid && mainLoginForm.get('passForLogin')?.touched"
                            required formControlName="passForLogin">
                        <img *ngIf="isPasswordHidden" (click)="showHidePass()" src="/assets/images/password-show.svg"
                            alt="show-password-icon" title="Show Password" class="passwordIcon" [ngClass]="{'passwordIconForLogin': isSignup}">
                        <img *ngIf="!isPasswordHidden" (click)="showHidePass()" src="/assets/images/password-hide.svg"
                            alt="hide-password-icon" title="Hide Password" class="passwordIcon" [ngClass]="{'passwordIconForLogin': isSignup}">
                        <a class="dmintLink forgotPass" href="/forgot-password">Forgot Password?</a>
                        <label *ngIf="false" class="formLabel" for="rememberMe">
                            <input type="checkbox" id="rememberMe" class="inputField">
                            <span class="styledCheckbox"></span>
                            Remember me
                        </label>
                    </div>

                    <div class="formControl" *ngIf="!isSignup && !signUpSteptwo">
                        <label class="formLabel required passForSignup" for="passForSignup">
                            Password
                        </label>
                        <input id="passForSignup" placeholder="Enter your password" autocomplete="false"
                            [type]="isPasswordHidden ? 'password' : 'text'" class="inputField"
                            [class.invalid]="mainLoginForm.get('passForSignup')?.invalid && mainLoginForm.get('passForSignup').dirty"
                            (focus)="onPasswordFocus()"
                            (blur)="onPasswordBlur()"
                            required formControlName="passForSignup">
                        <img *ngIf="isPasswordHidden" (click)="showHidePass()" src="/assets/images/password-show.svg"
                            alt="show-password-icon" title="Show Password" class="passwordIcon">
                        <img *ngIf="!isPasswordHidden" (click)="showHidePass()" src="/assets/images/password-hide.svg"
                            alt="hide-password-icon" title="Hide Password" class="passwordIcon">
                        
                        <div class="passRequirements" *ngIf="!isSignup && !signUpSteptwo && passwordReqVisible">
                            <p>Please make sure that the password contains:</p>
                            <ul>
                                <li>
                                    <img *ngIf="!isPasswordValid().hasSpecialCharacter"
                                        src="/assets/images/validateMe.svg" alt="before-valid-icon" title="validateMe"
                                        class="validateMe">
                                    <img *ngIf="isPasswordValid().hasSpecialCharacter"
                                        src="/assets/images/validatedMe.svg" alt="after-valid-icon" title="validated"
                                        class="validated">
                                    atleast one special character (e.g., !, &#64;, #, $, %, ^, &, *, etc.).
                                </li>
                                <li>
                                    <img *ngIf="!isPasswordValid().hasCapitalLetter" src="/assets/images/validateMe.svg"
                                        alt="before-valid-icon" title="validateMe" class="validateMe">
                                    <img *ngIf="isPasswordValid().hasCapitalLetter" src="/assets/images/validatedMe.svg"
                                        alt="after-valid-icon" title="validated" class="validated">
                                    atleast one capital case character and one lower case character
                                </li>
                                <li>
                                    <img *ngIf="!isPasswordValid().hasNumber" src="/assets/images/validateMe.svg"
                                        alt="before-valid-icon" title="validateMe" class="validateMe">
                                    <img *ngIf="isPasswordValid().hasNumber" src="/assets/images/validatedMe.svg"
                                        alt="after-valid-icon" title="validated" class="validated">
                                    atleast one number
                                </li>
                                <li>
                                    <img *ngIf="!isPasswordValid().isLongEnough" src="/assets/images/validateMe.svg"
                                        alt="before-valid-icon" title="validateMe" class="validateMe">
                                    <img *ngIf="isPasswordValid().isLongEnough" src="/assets/images/validatedMe.svg"
                                        alt="after-valid-icon" title="validated" class="validated">
                                    should have minimum length of 8 characters
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- OTP VERIFICATION FIELD - START -->
                    <div class="formControl otpVerification" *ngIf="!isSignup && signUpSteptwo">
                        <label class="formLabel required">
                            Verification Code
                        </label>
                        <!-- <div class="otpContainer">
                            <input 
                                *ngFor="let index of otpIndices; trackBy: trackByIndex"
                                [id]="'otpDigit' + (index + 1)"
                                type="text" 
                                inputmode="text"
                                pattern="[A-Za-z0-9]"
                                maxlength="1" 
                                class="otpInput"
                                (input)="onOtpDigitInput($event, index)"
                                (keydown)="onOtpKeyDown($event, index)"
                                (paste)="onOtpPaste($event, index)"
                                [formControlName]="'otpDigit' + (index + 1)"
                                [attr.aria-label]="getOtpAriaLabel(index + 1)"
                                autocomplete="one-time-code">
                        </div> -->
                            <input id="verificationCode" placeholder="Enter 8-digit code" autocomplete="false" type="text" class="inputField" required
                                formControlName="verificationCodeForSignUp"
                                [class.invalid]="resetForm.get('verificationCodeForSignUp')?.invalid">

                        <!-- <p style="display:flex; align-items: center;" class="resendLink">{{codeExpText}}
                            <span style="margin-left: 0.25rem;" *ngIf="isShowTimer"
                                class="resendLink">{{timer}}</span>
                            <button style="margin-left: 0.25rem;" *ngIf="!isShowTimer" class="dmintLink"
                                (click)="resendCode()">Resend Code</button>
                        </p> -->
                        <div class="errorCont" *ngIf="otpError">
                            <img src="../../../../assets/images/failed.svg" alt="">
                            <p>{{ otpError }}</p>
                        </div>
                    </div>
                    <!-- OTP VERIFICATION FIELD - END -->

                    

                    <!--<div class="rememberMe" *ngIf="isSignup">
                        <label class="formLabel" for="rememberMe">
                            <input type="checkbox" id="rememberMe" class="inputField">
                            <span class="styledCheckbox"></span>
                            Remember me
                        </label>
                    </div>-->

                    <button class="primary" type="submit" [disabled]="isMainLoginFormValid()">
                        {{ isSignup ? 'Login' : (signUpSteptwo ? 'Create your account' : 'Continue') }}
                    </button>
                    <p class="loginPrompt" *ngIf="isSignup">
                        New to DMINT?
                        <span>
                            <a (click)="showSignUp()" class="dmintLink">
                                {{ 'Create your Account' }}
                            </a>
                        </span>
                    </p>
                    <p class="signupPrompt" *ngIf="!isSignup && !signUpSteptwo">
                        Already on DMINT?
                        <span>
                            <a (click)="showLoginForm()" class="dmintLink">
                                {{ 'Log In' }}
                            </a>
                        </span>
                    </p>
                    <p class="otpHelper" *ngIf="!isSignup && signUpSteptwo">
                        Can't find your code? 
                        <a class="dmintLink" (click)="resendCodeForSignUp()">Request a new code</a>
                    </p>
                </form>
                <!-- FORMS SECTION - END -->
                <!-- TOAST NOTIFICATIONS - START -->
                <app-success-toast *ngIf="successMsg&&showSuccessToast" [message]="successMsg"></app-success-toast>
                <app-error-toast *ngIf="error && showErrorToast" [message]="error"></app-error-toast>
                <!-- TOAST NOTIFICATIONS - END -->
            </div>
            <!-- CONTENT CARD - END -->
        </div>
    </div>
    <!-- WRAPPER AND LAYOUT - END -->
</ng-container>
<!-- ROOT CONTAINER - END -->